export default __webpack_public_path__ + "static/media/671c0d778a1c49eaa1e93c3b666d7271.58fcfbb1.png";